import { Field, InputType, ObjectType } from 'type-graphql'

import { modelOptions, Prop } from '@typegoose/typegoose'
import type { CustomerTypeEnum } from './CustomerTypeEnum'
import { BillToUps } from './BillToUps'
import { User } from '../user/User'

@ObjectType('Customer')
@InputType('CustomerInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'users' } }) //we need to define the collection name here, as the users, because it will use that collection
export class Customer extends User {
  @Field(() => String)
  @Prop({ type: String })
  customerType: CustomerTypeEnum

  @Field(() => BillToUps)
  @Prop({ type: BillToUps })
  ups: BillToUps

  @Field(() => String)
  @Prop({ type: String })
  discount: string

  @Field(() => String)
  @Prop({ type: String })
  paymentTerms: string
}
